import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


const DataPolicies = ({ content }) => {
  return (
    <div className="post fade-in">
      <h1 className="text-center">Adatkezelési irányelvek</h1>
      {ReactHtmlParser(content)}
    </div>
  );
};


DataPolicies.propTypes = {
  content: PropTypes.string.isRequired
};

export default DataPolicies;




// WEBPACK FOOTER //
// ./src/components/DataPolicies/DataPolicies.js